import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = {
  key: 0,
  class: "inline-block ml-1"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DetailDeliverySection = _resolveComponent("DetailDeliverySection")!
  const _component_DetailBagging = _resolveComponent("DetailBagging")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_PrintManifest = _resolveComponent("PrintManifest")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb),
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.getTitle,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail
    }, {
      title: _withCtx(() => [
        (_ctx.isDisputeBagging)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_Icons, {
                name: "kg-dispute",
                class: "text-red-lp-100",
                style: {"width":"24px","height":"24px"}
              })
            ], 512)), [
              [
                _directive_tooltip,
                _ctx.$t('bagging.bagWithWeightDispute'),
                void 0,
                { bottom: true }
              ]
            ])
          : _createCommentVNode("", true)
      ]),
      data: _withCtx(() => [
        _createVNode(_component_DetailDeliverySection, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
        _hoisted_3,
        _createVNode(_component_DetailBagging, { detailData: _ctx.detailData }, null, 8, ["detailData"])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_LpButton, {
          customClass: "px-12 py-2.5 text-red-lp-100",
          title: _ctx.$t('Ubah'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToEdit(_ctx.$route.params.id))),
          iconLeft: "pencil-alt",
          outline: ""
        }, null, 8, ["title"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('bagging.createdBaggingDate'),
          value: _ctx.convertCreatedAt,
          caption: _ctx.detailData.baggingCreatedBy
        }, null, 8, ["label", "value", "caption"]),
        _hoisted_4,
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Print Bagging')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpButton, {
              onClick: _ctx.printManifest,
              class: "mt-3 w-48",
              flat: "",
              dense: "",
              iconLeft: "printer",
              title: _ctx.$t('Print PDF')
            }, null, 8, ["onClick", "title"]),
            _createVNode(_component_LpButton, {
              onClick: _ctx.printPdf,
              class: "w-48",
              flat: "",
              iconLeft: "invoice",
              dense: "",
              title: "Print Label"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _createVNode(_component_PrintManifest, { ref: "printManifest" }, null, 512)
  ]))
}